import { paymentHistoryService } from '../services'

export default (fromNum, resultsPerPage,filters) => {
	return new Promise(async (resolve, reject) => {
		await paymentHistoryService.getTransacciones(fromNum, resultsPerPage,filters)
			.then(response => resolve(response))
			.catch(err => reject({error: true}))
	})
}
